'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Icon2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/bee-icon@1.0.15_dcdmdzjel7sn5rgv2xzbvbfoxq/node_modules/bee-icon/build/index.js
// module id = 23
// module chunks = 0